<template>
  <div
    class="text-body-2 text-secondary--text text-center"
  >
    {{ t('Нажимая', options) }}
    «{{ t(isButtonSendVisible ? 'Отправить' : 'Подтвердить', options) }}»,
    {{ t('соглашаюсь с', options) }}
    <a
      href="/info/privacy-policy/"
      target="_blank"
      class="text-decoration-none primary--text d-inline"
    >{{ t('политикой обработки персональных данных', options) }}</a>
    {{ t('и принимаю', options) }}
    <a
      href="/info/terms-of-use/"
      target="_blank"
      class="text-decoration-none primary--text d-inline"
    >{{ t('пользовательское соглашение', options) }}</a>
  </div>
</template>

<script lang="ts" setup>
import I18NextVue from 'i18next'

defineProps<{
  isButtonSendVisible: boolean
}>()

const { t, language } = I18NextVue
const options = { ns: language }
</script>
